/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { encodeBase64 } from '../../utils/utilityFunctions';
import { CALL_API } from '../middleware';
import { USER_ROLES } from '../../utils/constant';
import {
  AcknowledgeAmlCheckRequestBody,
  AcknowledgeAmlCheckResponseBody,
  ApplicationProps,
  ConsentEmailApproveRejectRequestBody,
  ConsentEmailApproveRejectResponseBody,
  EnablePOARequestBody,
  EnablePOAResponseBody,
  esignApplicationResponse,
  GetDetailsFromRefIDResponse,
  GetOtpForInvestorRequestBody,
  GetOtpForInvestorResponse,
  getSalutationResponse,
  investmentDetailsAplicationRef,
  TrusteeEsignDetailsResponse,
  IsApplicableForPOAResponseBody,
  SendApplicationTokenRequestBody,
  SendConsentEmailRequestBody,
  SendConsentEmailResponseBody,
  SendEmailRequestBody,
  SendOtpRequestBody,
  SendOtpResponseBody,
  verifyInvestorResponse,
  VerifyOtpRequestBody,
  VerifyOtpResponseBody,
  VerifyPanRequestBody,
  VerifyPanResponseBody,
} from '../types/api-types';
import {
  GET_ALL_APPLICATION,
  GET_ALL_APPLICATION_SUCCESS,
  GET_APPLICATION,
  GET_APPLICATION_SUCCESS,
  GetAllTopUpApplication,
} from '../types/application';
import { VERIFY_OTP } from '../types/auth';
import {
  SEND_OTP,
  SEND_OTP_SUCCESS,
  VERIFY_PAN,
  VERIFY_PAN_SUCCESS,
  VERIF_OTP_SUCCESS,
  GET_DETAILS_SUCCESS,
  GET_DETAILS,
  GET_OTP_SUCCESS,
  GET_OTP,
  VERIFY_OTP_INVESTOR_SUCCESS,
  VERIFY_OTP_INVESTOR,
  GET_APPLICATION_WITH_REF_ID_SUCCESS,
  GET_APPLICATION_WITH_REF_ID,
  ESIGN_DOCUMENT_SUCCESS,
  ESIGN_DOCUMENT,
  GET_Investment_Details_Aplication_Ref_SUCCESS,
  GET_Investment_Details_Aplication_Ref,
  ENABLE_POA,
  ENABLE_POA_SUCCESS,
  APPLICABLE_FOR_POA_SUCCESS,
  APPLICABLE_FOR_POA,
  SEND_EMAIL_SUCCESS,
  SEND_EMAIL,
  ACKNOWLEDGE_AML_CHECK_SUCCESS,
  ACKNOWLEDGE_AML_CHECK,
  SEND_CONSENTEMAIL_SUCCESS,
  SEND_CONSENTEMAIL,
  SEND_CONSENTEMAIL_APPROVE_SUCCESS,
  SEND_CONSENTEMAIL_APPROVE,
  SEND_CONSENTEMAIL_REJECT_SUCCESS,
  SEND_CONSENTEMAIL_REJECT,
  SEND_APPLICATION_TOKEN_SUCCESS,
  SEND_APPLICATION_TOKEN,
  GET_SALUTATION_SUCCESS,
  GET_SALUTATION,
  UPDATE_SALUTATION_SUCCESS,
  UPDATE_SALUTATION,
  GET_APPLICATION_DOWNLOAD_SUCCESS,
  GET_APPLICATION_DOWNLOAD,
} from '../types/onBoarding';
import { getParams } from './application';

export const verifyPan =
  (body: VerifyPanRequestBody) =>
  async (dispatch: any): Promise<VerifyPanResponseBody> => {
    return await dispatch({
      [CALL_API]: {
        url: `/onboarding/onboarding/verify-pan`,
        method: 'POST',
        types: [VERIFY_PAN_SUCCESS, VERIFY_PAN],
        body: {
          payload: encodeBase64(
            JSON.stringify({
              pan: body.pan.toUpperCase(),
              dob: body.dob,
            })
          ),
        },
      },
    });
  };

export const sendOtp =
  (body: SendOtpRequestBody) =>
  async (dispatch: any): Promise<SendOtpResponseBody> => {
    return await dispatch({
      [CALL_API]: {
        url: `/onboarding/onboarding/send-otp`,
        method: 'POST',
        types: [SEND_OTP_SUCCESS, SEND_OTP],
        body: { payload: encodeBase64(JSON.stringify(body)) },
      },
    });
  };

export const verifyOtp =
  (body: VerifyOtpRequestBody) =>
  async (dispatch: any): Promise<VerifyOtpResponseBody> => {
    return await dispatch({
      [CALL_API]: {
        url: `/onboarding/onboarding/verify-otp`,
        method: 'POST',
        types: [VERIF_OTP_SUCCESS, VERIFY_OTP],
        body: { payload: encodeBase64(JSON.stringify(body)) },
      },
    });
  };

export const getDetailsWithReferenceId =
  (referenceId: string, isTopUp: boolean) =>
  async (dispatch: any): Promise<GetDetailsFromRefIDResponse> => {
    return await dispatch({
      [CALL_API]: {
        url: `/onboarding/${isTopUp ? 'topupEsigns' : 'esign'}/details/${referenceId}`,
        method: 'GET',
        types: [GET_DETAILS_SUCCESS, GET_DETAILS],
      },
    });
  };

export const getOtpForInvestor =
  (referenceId: string, isTopUp: boolean) =>
  async (dispatch: any): Promise<GetOtpForInvestorResponse> => {
    return await dispatch({
      [CALL_API]: {
        url: `/onboarding/${isTopUp ? 'topupEsigns' : 'esign'}/get-otp/${referenceId}`,
        method: 'GET',
        types: [GET_OTP_SUCCESS, GET_OTP],
      },
    });
  };

export const verifyOtpForInvestor =
  (referenceId: string, body: GetOtpForInvestorRequestBody, isTopUp: boolean) =>
  async (dispatch: any): Promise<verifyInvestorResponse> => {
    return await dispatch({
      [CALL_API]: {
        url: `/onboarding/${isTopUp ? 'topupEsigns' : 'esign'}/verify-otp/${referenceId}`,
        method: 'POST',
        types: [VERIFY_OTP_INVESTOR_SUCCESS, VERIFY_OTP_INVESTOR],
        body: { payload: encodeBase64(JSON.stringify(body)) },
      },
    });
  };

export const getApplicationDetailsWithRefId =
  (referenceId: string, isTopUp: boolean) =>
  async (dispatch: any): Promise<ApplicationProps> => {
    return await dispatch({
      [CALL_API]: {
        url: `/onboarding/${isTopUp ? 'topupEsigns' : 'esign'}/application-details/${referenceId}`,
        method: 'GET',
        types: [GET_APPLICATION_WITH_REF_ID_SUCCESS, GET_APPLICATION_WITH_REF_ID],
      },
    });
  };

export const getSalutation =
  () =>
  async (dispatch: any): Promise<getSalutationResponse> => {
    return await dispatch({
      [CALL_API]: {
        url: `/onboarding/salutations`,
        method: 'GET',
        types: [GET_SALUTATION_SUCCESS, GET_SALUTATION],
      },
    });
  };

export const UpdateAppliSalutation =
  (applicationId: string, body: Partial<ApplicationProps>) =>
  async (dispatch: any): Promise<esignApplicationResponse> => {
    return await dispatch({
      [CALL_API]: {
        url: `/onboarding/esign/${applicationId}/update-salutation`,
        method: 'POST',
        types: [UPDATE_SALUTATION_SUCCESS, UPDATE_SALUTATION],
        body,
      },
    });
  };

export const esignApplication =
  (referenceId: string, isTopUp: boolean) =>
  async (dispatch: any, getState: any): Promise<esignApplicationResponse> => {
    const { role = '' } = getState()?.auth || {};
    const isTrustee = role === USER_ROLES.TRUSTEE;
    const isIM = role === USER_ROLES.FUND_MANAGER;
    return await dispatch({
      [CALL_API]: {
        url: isIM
          ? `/onboarding/${isTopUp ? 'topupEsigns' : 'esign'}/fundmanager/sign/${referenceId}`
          : isTrustee
          ? `/onboarding/${isTopUp ? 'topupEsigns' : 'esign'}/trustee/sign/${referenceId}`
          : `/onboarding/${isTopUp ? 'topupEsigns' : 'esign'}/sign/${referenceId}`,
        method: 'POST',
        types: [ESIGN_DOCUMENT_SUCCESS, ESIGN_DOCUMENT],
      },
    });
  };

export const getTrusteeEsignDetails =
  (applicationId: string, isTopUp = false) =>
  async (dispatch: any): Promise<TrusteeEsignDetailsResponse> => {
    return await dispatch({
      [CALL_API]: {
        url: `/onboarding/${
          isTopUp ? 'topupEsigns' : 'esign'
        }/trustee/esign-details/${applicationId}`,
        method: 'GET',
        types: [
          GET_Investment_Details_Aplication_Ref_SUCCESS,
          GET_Investment_Details_Aplication_Ref,
        ],
      },
    });
  };
export const getIMEsignDetails =
  (applicationId: string, isTopUp = false) =>
  async (dispatch: any): Promise<TrusteeEsignDetailsResponse> => {
    return await dispatch({
      [CALL_API]: {
        url: `/onboarding/${
          isTopUp ? 'topupEsigns' : 'esign'
        }/fundmanager/esign-details/${applicationId}`,
        method: 'GET',
        types: [
          GET_Investment_Details_Aplication_Ref_SUCCESS,
          GET_Investment_Details_Aplication_Ref,
        ],
      },
    });
  };

export const ApplicationRefs =
  (applicationId: string | number, isTopUp: boolean) =>
  async (dispatch: any): Promise<investmentDetailsAplicationRef> => {
    return await dispatch({
      [CALL_API]: {
        url: `/onboarding/${isTopUp ? 'topupEsigns' : 'esign'}/get-referenceids/${applicationId}`,
        method: 'GET',
        types: [
          GET_Investment_Details_Aplication_Ref_SUCCESS,
          GET_Investment_Details_Aplication_Ref,
        ],
      },
    });
  };

export const EnablePOA =
  (body: EnablePOARequestBody) =>
  async (dispatch: any): Promise<EnablePOAResponseBody> => {
    return await dispatch({
      [CALL_API]: {
        url: `/onboarding/onboarding/enable-poa`,
        method: 'POST',
        types: [ENABLE_POA_SUCCESS, ENABLE_POA],
        body,
      },
    });
  };

export const IsApplicableForPOA =
  () =>
  async (dispatch: any): Promise<IsApplicableForPOAResponseBody> => {
    return await dispatch({
      [CALL_API]: {
        url: `/onboarding/amc/applicable-for-power-of-attorney`,
        method: 'GET',
        types: [APPLICABLE_FOR_POA_SUCCESS, APPLICABLE_FOR_POA],
      },
    });
  };

export const SendEmail =
  (body: SendEmailRequestBody) =>
  async (dispatch: any): Promise<VerifyOtpResponseBody> => {
    return await dispatch({
      [CALL_API]: {
        url: `/onboarding/onboarding/get-non-individual-application-token`,
        method: 'POST',
        types: [SEND_EMAIL_SUCCESS, SEND_EMAIL],
        body: { payload: encodeBase64(JSON.stringify(body)) },
      },
    });
  };

export const AcknowledgeAmlCheck =
  (body: AcknowledgeAmlCheckRequestBody) =>
  async (dispatch: any): Promise<AcknowledgeAmlCheckResponseBody> => {
    return await dispatch({
      [CALL_API]: {
        url: `/onboarding/onboarding/acknowledge-aml-check`,
        method: 'POST',
        types: [ACKNOWLEDGE_AML_CHECK_SUCCESS, ACKNOWLEDGE_AML_CHECK],
        body,
      },
    });
  };

export const sendConsentEmail =
  (body: SendConsentEmailRequestBody) =>
  async (dispatch: any): Promise<SendConsentEmailResponseBody> => {
    return await dispatch({
      [CALL_API]: {
        url: `/onboarding/onboarding/send-consent-email`,
        method: 'POST',
        types: [SEND_CONSENTEMAIL_SUCCESS, SEND_CONSENTEMAIL],
        body,
      },
    });
  };

export const approveConsentEmail =
  (body: ConsentEmailApproveRejectRequestBody) =>
  async (dispatch: any): Promise<ConsentEmailApproveRejectResponseBody> => {
    return await dispatch({
      [CALL_API]: {
        url: `/onboarding/onboarding-consent/approve`,
        method: 'POST',
        types: [SEND_CONSENTEMAIL_APPROVE_SUCCESS, SEND_CONSENTEMAIL_APPROVE],
        body,
      },
    });
  };

export const rejectConsentEmail =
  (body: ConsentEmailApproveRejectRequestBody) =>
  async (dispatch: any): Promise<ConsentEmailApproveRejectResponseBody> => {
    return await dispatch({
      [CALL_API]: {
        url: `/onboarding/onboarding-consent/reject`,
        method: 'POST',
        types: [SEND_CONSENTEMAIL_REJECT_SUCCESS, SEND_CONSENTEMAIL_REJECT],
        body,
      },
    });
  };

export const getApplicationToken =
  (body: SendApplicationTokenRequestBody) =>
  async (dispatch: any): Promise<VerifyOtpResponseBody> => {
    return await dispatch({
      [CALL_API]: {
        url: `/onboarding/onboarding/get-individual-application-token`,
        method: 'POST',
        types: [SEND_APPLICATION_TOKEN_SUCCESS, SEND_APPLICATION_TOKEN],
        body: { payload: encodeBase64(JSON.stringify(body)) },
      },
    });
  };

export const ApplicationDownload =
  (applicationId: string, isTopUp: boolean) =>
  async (dispatch: any): Promise<Blob> => {
    return await dispatch({
      [CALL_API]: {
        url: `/pdf/onboarding-application/${isTopUp ? 'topupPdf' : 'pdf'}/${applicationId}`,
        method: 'GET',
        types: [GET_APPLICATION_DOWNLOAD_SUCCESS, GET_APPLICATION_DOWNLOAD],
        contentType: 'application/pdf',
      },
    });
  };

export const topUpInit =
  (applicationId: string) =>
  async (dispatch: any): Promise<ApplicationProps> => {
    return await dispatch({
      [CALL_API]: {
        url: `/onboarding/topups/${applicationId}`,
        method: 'POST',
        types: [GET_APPLICATION_SUCCESS, GET_APPLICATION],
      },
    });
  };

export const getSpecificTopups =
  (topUpId: number | null, method = '') =>
  async (dispatch: any): Promise<ApplicationProps> => {
    return await dispatch({
      [CALL_API]: {
        url: `/onboarding/topups/${topUpId}`,
        method: method ? 'DELETE' : 'GET',
        types: [GET_APPLICATION_SUCCESS, GET_APPLICATION],
      },
    });
  };

export const getAllTopups =
  (params: Partial<GetAllTopUpApplication>) =>
  async (dispatch: any): Promise<GetAllTopUpApplication> => {
    await dispatch(getParams(params));
    return await dispatch({
      [CALL_API]: {
        url: '/onboarding/topups',
        method: 'GET',
        types: [GET_ALL_APPLICATION_SUCCESS, GET_ALL_APPLICATION],
        params: {
          limit: 10,
          ...params,
        },
      },
    });
  };

export const getTrusteeTopups =
  (params: Partial<GetAllTopUpApplication>) =>
  async (dispatch: any): Promise<GetAllTopUpApplication> => {
    await dispatch(getParams(params));
    return await dispatch({
      [CALL_API]: {
        url: '/onboarding/topups/trustee/my-topups',
        method: 'GET',
        types: [GET_ALL_APPLICATION_SUCCESS, GET_ALL_APPLICATION],
        params: {
          limit: 10,
          ...params,
        },
      },
    });
  };
export const getImTopups =
  (params: Partial<GetAllTopUpApplication>) =>
  async (dispatch: any): Promise<GetAllTopUpApplication> => {
    await dispatch(getParams(params));
    return await dispatch({
      [CALL_API]: {
        url: '/onboarding/topups/fundmanager/my-topups',
        method: 'GET',
        types: [GET_ALL_APPLICATION_SUCCESS, GET_ALL_APPLICATION],
        params: {
          limit: 10,
          ...params,
        },
      },
    });
  };

export const verifyApplicant =
  (applicantId: number, verificationToken: string) =>
  async (dispatch: any): Promise<verifyInvestorResponse> => {
    return await dispatch({
      [CALL_API]: {
        url: `/onboarding/topups/${applicantId}/verifyApplicant`,
        method: 'POST',
        types: [VERIFY_OTP_INVESTOR_SUCCESS, VERIFY_OTP_INVESTOR_SUCCESS],
        body: {
          applicantVerificationToken: verificationToken,
        },
      },
    });
  };
